module.exports = __webpack_public_path__ + "img/rdms.d4b3684b.png";